export default __webpack_public_path__ + "static/media/leftBottom.5344b6aa.png";